import router from "./router";
import store from "./store";
import i18n from "@/locales"; // internationalization
import {
  Message
} from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import {
  getToken
} from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration
const whiteList = ["/login", "/register", "/agreement", "/privacy", "/dashboard", ]; // no redirect whitelist
router.beforeEach(async (to, from, next) => {
  // console.log(to,from)
  // start progress bar
  NProgress.start();
  // set page title
  document.title = getPageTitle(i18n.t(to.meta.title));
  // 游客模式
  await store.dispatch("getSysInfo");
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({
        path: "/"
      });
      NProgress.done();
    } else {
      const hasGetUserInfo = store.getters.name;
      if (hasGetUserInfo) {
        next();
      } else {
        try {
          // get user info
          await store.dispatch("getInfo");
          // await store.dispatch("getSysInfo");
          next();
        } catch (error) {
          console.log(666);
          // remove token and go to login page to re-login
          await store.dispatch("resetToken");
          Message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next("/login");
      // next(`/login?redirect=${to.path}`);
      // NProgress.done();
      // console.log(to.path);
      next();
    }
  }
});
router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});